angular
    .module('empower.control')
    .directive("localitySearch", ['$rootScope', 'localityService', 'popupService',
        function ($rootScope, localityService, popupService) {
            return {
                restrict: 'E',
                templateUrl: 'module/control/localitySearch/locality-search.html',
                scope: {
                },
                controller: function ($scope) {
                    $scope.localityId = null;
                    $scope.placeholder = "Search for suburb, state or postcode";
                    $scope.rowsPerPage = 50;

                    $scope.fnQuery = function (childScope, key, callback) {
                        localityService.searchLocality(1, $scope.rowsPerPage, key).then(function (data) {
                            var list = data.Data.map(function (x) {
                                return {
                                    id: x.LocalityId,
                                    text: x.FullAddress,
                                    Suburb: x.Suburb,
                                    State: x.State,
                                    PostCode: x.PostCode
                                };
                            });

                            var result = {
                                results: list,
                                totalItems: data.RowsCount
                            };

                            childScope.currentList = list;
                            childScope.totalItemsFound = result.RowsCount;
                            childScope.totalItemsShown = result.RowsCount > $scope.rowsPerPage ? $scope.rowsPerPage : result.RowsCount;
                            childScope.cacheDataSource[key] = result;
                            callback(result);
                        });
                    }; // fnQuery

                    $scope.fnCurrent = function (childScope, callback) {
                        if (childScope.ngModel !== null && childScope.ngModel !== undefined) {
                            //only get policy info when another policy is selected
                            if (!childScope.selectedData || childScope.selectedData.id !== childScope.ngModel) {
                                // check if selected policy is in current list policy
                                var localityInfo = childScope.currentList.filter(function (p) {
                                    return p.id === childScope.ngModel;
                                })[0];

                                if (localityInfo) {
                                    childScope.selectedData = {
                                        id: localityInfo.id,
                                        text: localityInfo.text,
                                        Suburb: localityInfo.Suburb,
                                        State: localityInfo.State,
                                        PostCode: localityInfo.PostCode
                                    };
                                    callback([childScope.selectedData]);

                                } else {
                                    // policyService.getPolicyDetailForVic(childScope.ngModel).then(function (data) {
                                    //     childScope.selectedData = {
                                    //         id: data.EmployerId,
                                    //         text: data.PolicyNumber + ' - ' + (data.CompanyName || 'N/A'),
                                    //         EmployerId: data.EmployerId,
                                    //         CompanyName: data.CompanyName,
                                    //         PolicyNumber: data.PolicyNumber,
                                    //         StatusCode: data.StatusCode,
                                    //         Scheme: data.Scheme
                                    //     };
                                    //     $scope.setSelectedData(childScope.selectedData, callback, childScope);
                                    // });
                                }
                            } else {
                                callback([childScope.selectedData]);
                            }

                        } else {
                            var emitChange = !!childScope.selectedData;
                            callback([{
                                id: 'null',
                                text: $scope.placeholder
                            }]);
                        }
                    }; // fnCurrent

                    $scope.selectLocality = function(selectedData) {
                        $rootScope.$broadcast($scope.eventEmit, selectedData);
                        $scope.closePopup();
                    }

                    $scope.openLocalitySearch = function() {
                        var otpions = {
                            showHeader: false,
                            showCloseButton: false,
                            otherTheme: true
                        };
                        $scope.openPopup();
                    }

                    $scope.closeLocality = function() {
                        if ($scope.emitOnClose) {
                            $rootScope.$broadcast($scope.eventEmit, null);
                        }
                        
                        $scope.closePopup();
                    }

                    $scope.closePopup = function() {
                        $scope.showLocalityPopup = false;
                    }

                    $scope.openPopup = function() {
                        $scope.showLocalityPopup = true;
                    }

                    $scope.$on('show-locality-search-popup', function (event, options) {
                        $scope.eventEmit = options.eventEmit;
                        $scope.emitOnClose = options.emitOnClose || false;
                        $scope.openPopup();
                    });
                }, // controller
                link: function (scope, element, attrs) {
                } // link
            };
        }
    ])
